"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var csod = require("player-core");
var React = require("react");
var player_toaster_1 = require("player-toaster");
var Hyperlink_1 = require("player-common-controls/controls/Hyperlink");
var CustomToaster = (function (_super) {
    __extends(CustomToaster, _super);
    function CustomToaster(props) {
        var _this = _super.call(this, props) || this;
        _this._getToasterInstance = function (toaster) {
            _this.toaster = toaster;
            csod.notify.success = function (title, message) {
                return _this.toaster.notify('success', title, message);
            };
            csod.notify.error = function (title, message) {
                return _this.toaster.notify('error', title, message);
            };
            csod.notify.info = function (title, message) {
                return _this.toaster.notify('info', title, message);
            };
            csod.notify.warning = function (title, message) {
                return _this.toaster.notify('warning', title, message);
            };
            csod.notify['successWithLink'] = function (message, linkText, linkUrl, onClick, options) {
                if (options === void 0) { options = {}; }
                return _this.toaster.notify('success', React.createElement("div", null,
                    message,
                    React.createElement("br", null),
                    React.createElement(Hyperlink_1.Hyperlink, { text: linkText, onClick: onClick, url: linkUrl })), '', options);
            };
            csod.notify['error2'] = function (title, message) {
                return _this.toaster.notify('error', title, React.createElement("ul", null, message.split(/\|/g).map(function (x, i) { return (React.createElement("li", { key: i }, x)); })));
            };
        };
        return _this;
    }
    CustomToaster.prototype.render = function () {
        return (React.createElement("div", { className: 'app-wrapper' },
            React.createElement(player_toaster_1.default, { ref: this._getToasterInstance })));
    };
    return CustomToaster;
}(React.Component));
exports.CustomToaster = CustomToaster;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["CustomToaster"] = [];


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/4d5b8a78b9bd1a6f/src/.tmp/CustomToaster/CustomToaster.js
// module id = 349
// module chunks = 0